function csrfToken(): string {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta?.getAttribute('content') || ''
}

export async function apiFetch(path: string, options: RequestInit = {}): Promise<Response> {
  const response = await fetch(path, {
    ...options,
    headers: {
      'Accept': 'application/json',
      'X-CSRF-Token': csrfToken(),
      ...options.headers,
    },
  })

  if (response.status === 401 || response.redirected) {
    window.location.href = '/users/sign_in'
    throw new Error('Unauthorized')
  }

  return response
}
